import React from "react";
import { Box, Button, Divider, useTheme } from "@mui/material";
import HistoryList from "./HistoryList";
import DeleteIcon from "@mui/icons-material/Delete";

export default function LeftPanel({
  history,
  onFileParsed,
  onClearHistory,
  onOpenHistory,
  activeConvId,
  chatRef
}) {
  const theme = useTheme();
  const darkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 1 }}
    >
      {history.length > 0 && (
        <>
          <Divider
            sx={{
              my: 1,
              borderColor: darkMode
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.08)",
            }}
          />

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              position: "relative",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {/* <HistoryList
              items={history}
              collapsed={false}
              onItemClick={onOpenHistory}
              activeConvId={activeConvId}
            /> */}
            <HistoryList
  items={history}
  collapsed={false}
  onItemClick={(conv) => {
    chatRef?.current?.hideWelcome(); // ✅ hide WelcomeScreen
    onOpenHistory?.(conv);
  }}
  activeConvId={activeConvId}
  chatRef={chatRef} // optional if you want
/>


            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: 40,
                background: darkMode
                  ? "linear-gradient(to top, #1e293b, transparent)"
                  : "linear-gradient(to top, #f1f5f9, transparent)",
                pointerEvents: "none",
              }}
            />
          </Box>

          <Button
            size="small"
            onClick={onClearHistory}
            startIcon={<DeleteIcon />}
            sx={{
              alignSelf: "center",
              textTransform: "none",
              borderRadius: "12px",
              px: 2,
              py: 1,
              mt: 1,
              mb: 1,
              fontSize: "0.85rem",
              fontWeight: 500,
              borderColor: darkMode ? "#ef4444" : "#dc2626",
              color: darkMode ? "#f87171" : "#b91c1c",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: darkMode
                  ? "rgba(239, 68, 68, 0.1)"
                  : "rgba(220, 38, 38, 0.08)",
                borderColor: darkMode ? "#f87171" : "#dc2626",
                transform: "scale(1.03)",
              },
              "& .MuiButton-startIcon": { marginRight: "4px" },
            }}
          >
            Delete
          </Button>
        </>
      )}
    </Box>
  );
}
